export const USA_TOPO_BASEMAP_TITLE = 'USA Topo Maps';
export const USA_TOPO_BASEMAP_THUMBNAIL_URL =
  'https://www.arcgis.com/sharing/rest/content/items/99cd5fbd98934028802b4f797c4b1732/info/thumbnail/USA_Topo_Thumbnails.jpg';
export const USA_TOPO_BASEMAP_URL = 'https://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer';

export const ESRI_TOPO_BASEMAP_TITLE = 'Topographic';
export const ESRI_BASEMAPS_TITLES = ['Dark Gray Canvas', 'Imagery Hybrid', 'OpenStreetMap', ESRI_TOPO_BASEMAP_TITLE];
